<template>
  <a-card :bordered="false">
    <a-tabs v-model:activeKey="tabsCp.active">
      <a-tab-pane :key="1" tab="代发品牌商">
        <agencyPaymentBrand />
      </a-tab-pane>
      <a-tab-pane :key="3" tab="代发配置项">
        <agencyPaymentConfig />
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>
<script>
import { ref, reactive } from "vue";
import agencyPaymentConfig from "./components/agencyPaymentConfig.vue";
import agencyPaymentBrand from "./components/agencyPaymentBrand.vue";
export default {
  name: "playSet",
  components: { agencyPaymentConfig, agencyPaymentBrand },
  setup() {
    let tabsCp = reactive({
      active: 1
    });
    return {
      tabsCp
    };
  }
};
</script>
